import { regularWhite } from '@ui-components/design-tokens';
import PlayText, { SIZE } from '@ui-components/typography/PlayText';
import React from 'react';
import { EditModeWrapper, OverlayContent, HiddenTitle } from './EditMode.styles';

type Props = {
    markedAsDeleted: boolean;
    programTitle: string;
};

const EditMode = ({ markedAsDeleted, programTitle }: Props): JSX.Element => (
    <EditModeWrapper aria-live="polite">
        {markedAsDeleted ? (
            <OverlayContent size={SIZE.SMALL}>{programTitle} har tagits bort ur listan.</OverlayContent>
        ) : (
            <PlayText dataRt="delete-program-button" fontColor={regularWhite} underline>
                Ta bort <HiddenTitle> : {programTitle}.</HiddenTitle>
            </PlayText>
        )}
    </EditModeWrapper>
);

export default EditMode;
